import React from 'react';
import PropTypes from 'prop-types';

export default function VideoIframeEmbed({ src, title }) {
  return (
    <div
      className="liveblog-card__leadmedia leadvideo"
    >
      <iframe
        title={title}
        src={src}
        frameBorder="0"
        seamless="seamless"
        allow="autoplay;encrypted-media"
        allowFullScreen
      />
    </div>
  );
}

VideoIframeEmbed.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string,
};

VideoIframeEmbed.defaultProps = {
  title: '',
};
